import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';
import { SiteRouteParams } from './core/routeparams';

@Injectable()
export class SelectedSiteService {
  private selectedSiteId$$ = new ReplaySubject<string>(1);

  resolve(route: ActivatedRouteSnapshot): string | null {
    const siteId = (route.params as SiteRouteParams).siteId;
    if (siteId) {
      this.selectedSiteId$$.next(siteId);
      return siteId;
    }
    return null;
  }

  public getSiteId(): Observable<string> {
    return this.selectedSiteId$$.pipe(distinctUntilChanged(), shareReplay());
  }
}
